import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {SelectChangeEvent} from "primeng/select";

@Component({
    selector: 'app-select-input',
    templateUrl: './select-input.component.html',
    standalone: false
})
export class SelectInputComponent implements OnInit{

  @Input() formGroup: FormGroup
  @Input() id: string
  @Input() placeholder: string
  @Input() label: string
  @Input() formError: string
  @Input() options: any[]
  /** Classes extra no contentor FloatLabel (ex.: mb-4 nos filtros) */
  @Input() wrapperClass = ''

  @Output('onChange') onChangeEventEmitter = new EventEmitter<SelectChangeEvent>()

  constructor() {
  }

  onChangeValue($value: SelectChangeEvent) {
    this.onChangeEventEmitter.emit($value)
  }

  ngOnInit(): void {

  }

}
